var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "-2 -2 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1725 2.77048L11.7299 4.32711L10.1725 2.77048ZM11.174 1.39914L6.96291 5.61021C6.74533 5.82749 6.59693 6.10432 6.53644 6.40581L6.14746 8.35289L8.09454 7.96318C8.39601 7.90288 8.67249 7.75509 8.89014 7.53744L13.1012 3.32637C13.2278 3.19982 13.3281 3.04959 13.3966 2.88426C13.4651 2.71892 13.5003 2.54171 13.5003 2.36275C13.5003 2.18379 13.4651 2.00659 13.3966 1.84125C13.3281 1.67591 13.2278 1.52568 13.1012 1.39914C12.9747 1.2726 12.8244 1.17222 12.6591 1.10373C12.4938 1.03525 12.3166 1 12.1376 1C11.9586 1 11.7814 1.03525 11.6161 1.10373C11.4508 1.17222 11.3005 1.2726 11.174 1.39914V1.39914Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0295 9.82372V12.0296C12.0295 12.4197 11.8746 12.7937 11.5988 13.0695C11.323 13.3453 10.9489 13.5002 10.5589 13.5002H2.4706C2.08057 13.5002 1.70652 13.3453 1.43073 13.0695C1.15494 12.7937 1 12.4197 1 12.0296V3.94131C1 3.55128 1.15494 3.17722 1.43073 2.90143C1.70652 2.62564 2.08057 2.4707 2.4706 2.4707H4.67651",
    stroke: "#2B2B2B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.06c94b8a8e2e4755f5eca2239b92ac25.svg";
export { ForwardRef as ReactComponent };